"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.common = exports.errorMessage = void 0;

var _feature = require("./feature");

var common = {
  availableFeatureTypes: Object.values(_feature.FEATURE_TYPES).join(", "),
  availableEventTypes: Object.values(_feature.EVENT_TYPES).join(", ")
};
exports.common = common;
var errorMessage = {
  invalidEnv: "You must provide a valid env value. Valid env values include: 'us', 'ca', 'us-snd', and 'ca-snd'",
  invalidFeatureType: featureType => "".concat(featureType, " is not a valid featureType. Valid featureType values include: ").concat(common.availableFeatureTypes),
  invalidEventType: eventType => "".concat(eventType, " is not a valid eventType. Valid feature eventType values include: ").concat(common.availableEventTypes),
  invalidMountPoint: "Could not find the mount point for the iframe. Please check that the elementId provided in .mount() matches the one that's used in the DOM"
};
exports.errorMessage = errorMessage;